/* eslint-disable spaced-comment */
import React, { useEffect, useState } from 'react';
import { api } from 'react-structure-admin';
import moment from 'moment';
import { Button, DatePicker, Row, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { MaskedInput } from 'antd-mask-input';
import { formartOnlyNumber } from 'util/formatters';
import useScreenSize from 'core/hooks/useScreenSize';
import useAuth from 'core/hooks/useAuth';
import ResCol from './ResCol';
import 'moment/locale/pt-br';

const SelectScheduled = ({
  value,
  onChange,
  disabled,
  serviceProviderId,
  tenantId
}) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const { isMobile } = useScreenSize();
  const { settings } = user;

  const setPeriod = (startTime, endTime) => {
    if (onChange) {
      onChange({
        startTime: moment(startTime),
        endTime: moment(endTime)
      });
    }
  };

  const handleChange = (date) => {
    setPeriod(date, date);
  };

  const handleChangeStartTime = (startTime) => {
    if (formartOnlyNumber(startTime).length > 3) {
      const startDate = moment(value?.startTime);
      startDate.set('hour', 0);
      startDate.set('minute', 0);
      startDate.add(moment(startTime, 'HH:mm').hour(), 'hour');
      startDate.add(moment(startTime, 'HH:mm').minute(), 'minute');
      const endDate = startDate.clone();
      endDate.add(settings?.durationOfService, 'minute');

      if (onChange) {
        onChange({
          startTime: startDate,
          endTime: endDate
        });
      }
    }
  };

  const handleChangeEndTime = (endTime) => {
    if (formartOnlyNumber(endTime).length > 3) {
      const endDate = moment(value?.endTime);
      endDate.set('hour', 0);
      endDate.set('minute', 0);
      endDate.add(moment(endTime, 'HH:mm').hour(), 'hour');
      endDate.add(moment(endTime, 'HH:mm').minute(), 'minute');

      if (onChange) {
        onChange({
          startTime: value?.startTime,
          endTime: endDate
        });
      }
    }
  };

  const fetchNextPeriod = (date) => {
    if (serviceProviderId) {
      api
        .fetch('health-service-providers/next-period', {
          serviceProviderId,
          tenantId,
          startDate: moment(date).format('MM-DD-YYYY HH:mm'),
          endDate: moment(date)
            .add(15, 'day')
            .format('MM-DD-YYYY HH:mm'),
          firstAvailable: true
        })
        .then((response) => {
          if (!response?.errors) {
            const { data } = response;
            const { startTime, endTime, ...rest } = data.result;
            if (onChange) {
              onChange({
                ...rest,
                startTime: moment(startTime),
                endTime: moment(endTime)
              });
            }
          }
        });
    }
  };

  const handleChangeNextTime = () => {
    if (!disabled) {
      fetchNextPeriod(value?.endTime ?? moment());
    }
  };

  useEffect(() => {
    if (value === null) {
      fetchNextPeriod(moment());
    }

    if (
      value?.serviceProvider &&
      value.serviceProvider?.id !== serviceProviderId
    ) {
      fetchNextPeriod(moment());
    }
  }, [value, serviceProviderId]);

  return (
    <Row className="gx-flex-row" gutter={[10, 10]}>
      <ResCol span={7}>
        <DatePicker
          format="DD/MM/YYYY"
          onChange={handleChange}
          value={moment(value?.startTime)}
          allowClear={false}
          disabled={disabled}
          open={open}
          onClick={() => setOpen(true)}
          onSelect={() => setOpen(false)}
          onBlur={() => setOpen(false)}
        />
      </ResCol>
      <ResCol span={17}>
        <div className="gx-d-flex gx-flex-nowrap gx-align-items-center">
          <MaskedInput
            mask="11:11"
            disabled={disabled}
            value={
              value?.startTime ? moment(value?.startTime).format('HH:mm') : null
            }
            onChange={(e) => handleChangeStartTime(e.target.value)}
          />
          <span className="gx-ml-2 gx-mr-2">às</span>

          <MaskedInput
            mask="11:11"
            disabled={disabled}
            value={
              value?.endTime ? moment(value?.endTime).format('HH:mm') : null
            }
            onChange={(e) => handleChangeEndTime(e.target.value)}
          />

          <Button
            className="gx-mb-0 gx-ml-1"
            type="link"
            disabled={disabled}
            icon={
              <Tooltip title="Próximo horário" placement="topLeft">
                <ReloadOutlined />
              </Tooltip>
            }
            onClick={handleChangeNextTime}
          >
            {!isMobile ? 'Próximo horário' : null}
          </Button>
        </div>
      </ResCol>
    </Row>
  );
};

export default SelectScheduled;
